import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ReportTemplateFieldDefinition, ReportTemplateFieldStyle } from 'src/dto/report-template';
import { InputV2Module, ToggleV2Module, ButtonV2Module } from '@schenck/rotec-components';

@Component({
  selector: 'rc-template-toolbox-item-freetext',
  templateUrl: './template-toolbox-item-freetext.component.html',
  styleUrls: ['./template-toolbox-item-freetext.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [InputV2Module, ToggleV2Module, ButtonV2Module],
})
export class TemplateToolboxItemFreetextComponent {
  @Input() item: ReportTemplateFieldDefinition;
  @Output() onDeleteItem: EventEmitter<ReportTemplateFieldDefinition>;

  public ReportTemplateFieldStyle = ReportTemplateFieldStyle;
  public style: ReportTemplateFieldStyle[];
  public active = false;

  constructor() {
    this.onDeleteItem = new EventEmitter<ReportTemplateFieldDefinition>();
  }

  public deleteItem(item: ReportTemplateFieldDefinition): void {
    this.onDeleteItem.emit(item);
  }

  public toggleStatusChanged(status): void {
    this.active = status;
    this.item.style = !!this.active ? ReportTemplateFieldStyle.Bold : ReportTemplateFieldStyle.None;
  }
}
